import { useEffect, useRef, useState } from "react";
import buildResizableDataTable from "./buildResizableDataTable";
import { DataTableRow } from "./DataTableRow";
import { usePrevious } from "../../hooks";
import { addRows, deleteRows, updateRow } from "./addRows";

export default function DataTable({
  colDefs,
  data,
  dataId,
  resizable,
  allowHiddenColumns,
  scrollX,
  editElement,
  deleteElement,
  dataTemplate,
  ...other
}) {
  const dragAndDropContainerId = `t${dataId}ColumnDrop`;
  const hiddenHeadersTableId = `t${dataId}HiddenColumns`;
  const [table, setTable] = useState();
  const formRef = useRef();
  const inputRef = useRef();
  const callBackRef = useRef();
  const isInitialMount = useRef(true);
  const [tableData, setTableData] = useState();
  const prevData = usePrevious(data);
  const ref = useRef([]);

  useEffect(() => {
    /*     console.log("DATATABLE", data);
     */ if (data !== undefined) {
      if (!tableData) {
        setTableData([...data]);
      }
      if (isInitialMount.current) {
        isInitialMount.current = false;
      } else if (data.toString() != prevData.toString()) {
        //Create
        ref.current = data?.filter((e) => {
          return !prevData?.includes(e);
        });
        if (ref.current?.length > 0) {
          setTableData([...data]);
        }
        //Delete
        deleteRows(
          table,
          prevData?.filter((e) => {
            return !data?.includes(e);
          })
        );
      }
    }
  }, [data?.toString()]);

  useEffect(() => {
    if (tableData !== undefined) {
      let tableHandle = buildResizableDataTable(
        "t" + dataId,
        tableData,
        dragAndDropContainerId,
        hiddenHeadersTableId,
        colDefs,
        scrollX
      );
      setTable(tableHandle);
      /*       console.log(tableData);
       */ addRows(tableHandle, ref.current);
    }
  }, [tableData]);

  useEffect(() => {
    // Bind the event listener
    //document.getElementById("root").addEventListener("mousedown", handleClickOutside);
    document
      .getElementsByTagName("body")[0]
      .addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      //document.getElementById("root").removeEventListener("mousedown", handleClickOutside);
      document
        .getElementsByTagName("body")[0]
        .removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function editRow(dataElement, rowIndex) {
    editElement(dataElement, rowIndex);
    console.log("dataElement", dataElement);
    console.log("rowIndex", rowIndex);
    updateRow(table, dataElement?._id);
  }

  function deleteRow(id, rowIndex) {
    deleteElement(id, rowIndex);
  }

  function handleClickOutside(event) {
    if (!formRef.current?.contains(event.target)) {
      callBackRef.current?.updateValue();
    }
  }

  return (
    <>
      {allowHiddenColumns && (
        <>
          <div className="row" style={{ position: "relative" }}>
            <label className="m-t-10">
              Arrastra columnas al recuadro para ocultarlas
            </label>
            <button
              id="btnResetView"
              className="btn btn-rounded btn-purple m-b-5"
              style={{ position: "absolute", right: "0" }}
            >
              <i className="fas fa-rotate-left"></i> Restablecer vista
            </button>
          </div>
          <div
            id={dragAndDropContainerId}
            className="row table-bordered m-b-10"
            style={{ overflowX: "auto" }}
          >
            <table
              id={hiddenHeadersTableId}
              className="table table-bordered panel-group m-0"
              style={{
                minHeight: "60px",
                width: "min-content",
                cursor: "pointer",
              }}
            ></table>
          </div>
        </>
      )}
      <div
        className="row"
        style={{ overflowX: "hidden", position: "relative" }}
      >
        <table id={`t${dataId}`} {...other}>
          <thead>
            <tr key={dataId}>
              {colDefs.map((colDef) => {
                return (
                  <th key={colDef.name}>{colDef.metadata?.visibleName}</th>
                );
              })}
            </tr>
          </thead>
          <tbody id={`tb${dataId}`} role="tablist">
            {tableData?.map((dataElement, rowIndex) => {
              return (
                <DataTableRow
                  rowIndex={rowIndex}
                  formRef={formRef}
                  inputRef={inputRef}
                  key={rowIndex}
                  callBackRef={callBackRef}
                  dataElement={dataElement}
                  colDefs={colDefs}
                  editRow={editRow}
                  deleteRow={deleteRow}
                  dataTemplate={dataTemplate}
                  /*                   videocallCallback={other.videocallCallback}
                   */
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
